import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import MockupImage from "../images/mockup1-left.png";
import CouponMockup1 from "../images/coupon_mockup_1.png";
import CouponMockup2 from "../images/coupon_mockup_2.png";

const WhatWeDo: React.FC = () => {
  const { t } = useLocale();

  // normalize section strings to avoid accidental key mixups
  const section1Title = t?.what?.sectionTitle ?? '';
  const section1Tagline = t?.what?.tagline ?? '';
  const section1Bullets: string[] = Array.isArray(t?.what?.bullets) ? t.what.bullets : [];

  const section2Title = t?.what?.sectionTitle2 ?? section1Title;
  const section2Tagline = t?.what?.tagline2 ?? section1Tagline;
  const section2Bullets: string[] = Array.isArray(t?.what?.bullets2) ? t.what.bullets2 : section1Bullets;

  return (
  <section id="what" className="py-10">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top title block (photo style) */}
        <div className="mb-10">
          <div className="w-60 h-1 bg-primary-gradient1 mx-auto mb-10" />
          <h1 className="text-5xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-primary-dark leading-tight text-center lg:text-left">{t.what.mainTitle}</h1>
          <p className="mt-4 text-3xl md:text-xl text-primary-gradient1 max-w-3xl mx-auto text-center">"{t.what.tagline}"</p>
        </div>

        {/* Section 1 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          {/* Left column: mockup image with overlay card */}
          <div className="w-full flex justify-center lg:justify-start">
            <div className="relative w-full max-w-[400px]">
              <img
                src={MockupImage}
                alt="App mockup"
                className="w-full object-contain transform md:-rotate-6"
              />

              {/* Overlay card positioned bottom-right of the mockup */}
              <div className="absolute right-6 bottom-4 md:right-32 md:bottom-8 z-20 w-[260px] md:w-[320px] bg-white rounded-xl shadow-lg p-4 md:p-6 border border-white/20">
                <h3 className="text-sm md:text-base font-semibold text-primary-dark heading-font mb-2">{t.reviews.title}</h3>
                <p className="text-xs md:text-sm text-gray-700 body-font italic">"{t.reviews.example}"</p>
                <div className="mt-3 text-xs text-gray-500">{t.reviews.generatedBy}</div>
              </div>
            </div>
          </div>

          {/* Right column: title + bullets */}
          <div className="w-full flex flex-col justify-center">
            <div className="mb-6">
              <div className="w-24 h-1 bg-primary-gradient1 mb-6" />
              <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-4">{section1Title}</h2>
              <p className="text-lg md:text-xl text-primary-gradient1 max-w-xl">{section1Tagline}</p>
            </div>

            <div className="mt-6 space-y-5">
              {section1Bullets && section1Bullets.map((b: string, i: number) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="mt-1">
                    <span className="inline-block w-4 h-4 rounded-full border-2 border-primary-gradient1" />
                  </div>
                  <p className="text-base md:text-lg text-gray-700 leading-relaxed">{b}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
        {/* Section 2 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        
          {/* Left column: title + bullets */}
          <div className="w-full flex flex-col justify-center order-2 lg:order-1">
            <div className="mb-6 mt-10">
              <div className="w-24 h-1 bg-primary-gradient1 mb-6" />
              <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-4">{section2Title}</h2>
              <p className="text-lg md:text-xl text-primary-gradient1 max-w-xl">{section2Tagline}</p>
            </div>

            <div className="mt-6 space-y-5">
              {section2Bullets && section2Bullets.map((b: string, i: number) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="mt-1">
                    <span className="inline-block w-4 h-4 rounded-full border-2 border-primary-gradient1" />
                  </div>
                  <p className="text-base md:text-lg text-gray-700 leading-relaxed">{b}</p>
                </div>
              ))}
            </div>
          </div>
            {/* Right column: mockup image with overlay card */}
          <div className="w-full flex justify-center lg:justify-start order-1 lg:order-2 mt-20 lg:mt-0">
            <div className="relative w-full max-w-[520px]">
                  <div className="w-full max-w-[550px] lg:max-w-[600px] lg:ml-10 flex flex-row flex-wrap gap-5 items-center justify-center">
                    <div className="flex-1 flex items-center justify-center">
                    <img
                      src={CouponMockup1}
                      alt="Coupon mockup 1"
                      className="w-full sm:w-1/2 object-contain"
                      style={{ boxShadow: 'none', border: 'none' }}
                    />
                    </div>
                    <div className="flex-1 flex items-center justify-center">
                    <img
                      src={CouponMockup2}
                      alt="Coupon mockup 2"
                      className="w-full sm:w-1/2 object-contain"
                      style={{ boxShadow: 'none', border: 'none' }}
                    />
                    </div>
                  </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
